import { defineModule } from '@/app/router/defineModule.ts';

export default defineModule({
    name: 'dev',
    routes: [
        {
            path: '/_dev',
            name: 'dev preview index',
            component: () => import('#modules/dev/pages/index.vue'),
            meta: {
                layout: 'blank',
            },
        },
        {
            path: '/_dev/alerts',
            name: 'dev preview alerts',
            component: () => import('#modules/dev/pages/previews/alerts.vue'),
            meta: {
                layout: 'blank',
            },
        },
        {
            path: '/_dev/buttons',
            name: 'dev preview buttons',
            component: () => import('#modules/dev/pages/previews/buttons.vue'),
            meta: {
                layout: 'blank',
            },
        },
        {
            path: '/_dev/form-fields',
            name: 'dev preview form-fields',
            component: () => import('#modules/dev/pages/previews/form-fields.vue'),
            meta: {
                layout: 'blank',
            },
        },
        {
            path: '/_dev/inputs',
            name: 'dev preview inputs',
            component: () => import('#modules/dev/pages/previews/inputs.vue'),
            meta: {
                layout: 'blank',
            },
        },
    ],
});
